module.exports = __webpack_public_path__ + "img/SG.0c14f708.svg";